module.exports = __webpack_public_path__ + "img/ah_logo.125c2f5d.png";